import { Grid } from '@mui/material';
import useWindowSize from '../hooks/useWindowResize';
import { useTheme } from '@mui/material/styles';
import InfoCard from '../components/Card/InfoCard';
import { useIntl } from 'react-intl';

const AboutUs = () => {
	const { width } = useWindowSize();
	const theme = useTheme();

 	const {
 		messages: {
 			aboutUsCards: {
 			rajabGazaqh,
 				ehsanVakili,
 				boranBayeva,
 				berdinazarOvezov,
 				abdazizSakhi,
 				hamedAbbasi,
 				safarAraghbai,
 				asefNazerian,
 			},
 		},
 	} = useIntl();

	const companies = [
		{
			name: rajabGazaqh.name,
			logo: '/assets/Images/logos/AltynGroup.png',
			logoAlt: 'Altyn Group',
			countryFlag: '/assets/Images/flags/Iran.png',
			languages: rajabGazaqh.languages,
			profileImg: '/assets/Images/profiles/AltynGroupCEO.png',
			profileImgAlt: 'Rajab Ghazagh',
			mobile: '989381929524',
			extra: rajabGazaqh.extra,
		},
		{
			name: safarAraghbai.name,
			role: safarAraghbai.role,
			logo: '/assets/Images/logos/AltynRail.jpg',
			logoAlt: 'Altyn Rail',
			countryFlag: '/assets/Images/flags/Iran.png',
			languages: safarAraghbai.languages,
			profileImg: '/assets/Images/profiles/SaparAriqbay.png',
			profileImgAlt: 'Safar Araghbai',
			mobile: '989032218538',
			location: safarAraghbai.location,
			description: safarAraghbai.description,
		},
		{
			name: ehsanVakili.name,
			role: ehsanVakili.role,
			logo: '/assets/Images/logos/AltynMiras.jpeg',
			logoAlt: 'Altyn Miras',
			countryFlag: '/assets/Images/flags/Iran.png',
			languages: ehsanVakili.languages,
			profileImg: '/assets/Images/profiles/EhsanVakili.jpg',
			profileImgAlt: 'Ehsan Vakili',
			mobile: '989025313535',
			location: ehsanVakili.location,
			description: ehsanVakili.description,
		},
				{
			name: asefNazerian.name,
			role: asefNazerian.role,
			logo: '/assets/Images/logos/AltynSareban.png',
			logoAlt: 'Altyn Rail',
			countryFlag: '/assets/Images/flags/Iran.png',
			languages: asefNazerian.languages,
			profileImg: '/assets/Images/profiles/AsefNazerian.png',
			profileImgAlt: 'Asef Nazerian',
			mobile: '989032218538',
			location: asefNazerian.location,
			description: asefNazerian.description,
		},
		{
			name: boranBayeva.name,
			role: boranBayeva.role,
			logo: '/assets/Images/logos/AltynLogisticKZ.png',
			logoAlt: 'Altyn Logistic KZ',
			countryFlag: '/assets/Images/flags/Kazakhstan.png',
			languages: boranBayeva.languages,
			profileImg: '/assets/Images/profiles/BoranbayevaGulnaraZharylkasynovna.jpg',
			profileImgAlt: 'Boranbayeva Gulnara Zharylkasynovna',
			mobile: '77015407993',
			location: boranBayeva.location,
			description: boranBayeva.description,
		},
		{
			name: berdinazarOvezov.name,
			role: berdinazarOvezov.role,
			logo: '/assets/Images/logos/AltynHayat.png',
			logoAlt: 'Altyn Hayat',
			countryFlag: '/assets/Images/flags/Turkmenistan.png',
			languages: berdinazarOvezov.languages,
			profileImg: '/assets/Images/profiles/BerdinazarOvezov.jpg',
			profileImgAlt: 'Berdinazar Ovezov',
			mobile: '99363000136',
			location: berdinazarOvezov.location,
			description: berdinazarOvezov.description,
		},
		{
			name: abdazizSakhi.name,
			role: abdazizSakhi.role,
			logo: '/assets/Images/logos/AltynAfghan.jpg',
			logoAlt: 'Altyn Afghan',
			countryFlag: '/assets/Images/flags/Afghanistan.jpg',
			languages: abdazizSakhi.languages,
			profileImg: '/assets/Images/profiles/AltynAfghanCEO.jpg',
			profileImgAlt: 'Abdul aziz Sakhi',
			mobile: '93749999117',
			location: abdazizSakhi.location,
			description: abdazizSakhi.description,
		},
		{
			name: hamedAbbasi.name,
			role: hamedAbbasi.role,
			logo: '/assets/Images/logos/AltynTech.png',
			logoAlt: 'Altyn Tech',
			countryFlag: '/assets/Images/flags/Iran.png',
			languages: hamedAbbasi.languages,
			profileImg: '/assets/Images/profiles/HamedAbbasi.jpg',
			profileImgAlt: 'Hamed Abbasi',
			mobile: '989112738596',
			location: hamedAbbasi.location,
			description: hamedAbbasi.description,
		},
	];

	return (
		<Grid
			py={{ xs: '50px', md: '100px' }}
			px={{ xs: '10px', s: '3%', md: '5%', lg: '10%' }}
		>
			<Grid
				display={'grid'}
				gridTemplateColumns={{
					xs: '1fr',
					md: 'repeat(2, 1fr)',
				}}
				rowGap={'40px'}
				columnGap={width > theme.breakpoints.values.md ? '5%' : '3%'}
			>
				{companies.map(
					(
						{
							name,
							role,
							logo,
							logoAlt,
							countryFlag,
							languages,
							profileImg,
							profileImgAlt,
							mobile,
							email,
							location,
							description,
							extra,
						},
						index
					) => (
						<InfoCard
							key={index}
							{...{
								name,
								role,
								logo,
								logoAlt,
								countryFlag,
								languages,
								profileImg,
								profileImgAlt,
								mobile,
								email,
								location,
								description,
								extra,
							}}
						/>
					)
				)}
			</Grid>
		</Grid>
	);
};

export default AboutUs;
